<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-10">
            <div class="py-5 px-5 px-md-0">
                <div class="d-flex align-items-center mb-5">
                    <div class="mr-3">
                        <app-icon name="layers"/>
                    </div>
                    <div>
                        <p class="mb-0">
                            Total {{ data.products.length }} products
                        </p>
                        <p class="mb-0 text-muted">
                            <span class="text-muted">From various categories</span>
                        </p>
                    </div>
                </div>
                <div class="row align-items-center mb-5" v-for="product in data.products">
                    <div class="col-md-4 mb-4 mb-md-0">
                        <div class="d-flex align-items-center">
                            <div class="mb-1">
                                <app-product-media :row-data="product"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('purchase_price') }}:</span>
                            {{ numberWithCurrencySymbol($optional(product, 'purchase_price')) }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('sell_price') }}:</span>
                            {{ numberWithCurrencySymbol($optional(product, 'sell_price')) }}
                        </p>
                    </div>
                    <div class="col-md-2 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('quantity') }}:</span>
                            {{ $optional(product, 'pivot', 'quantity') }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('price') }}:</span>
                            {{ numberWithCurrencySymbol($optional(product, 'pivot', 'price')) }}
                        </p>
                    </div>
                    <div class="col-md-2 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('discount') }}:</span>
                            {{ numberWithCurrencySymbol($optional(product, 'pivot', 'discount')) }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('total') }}:</span>
                            {{ numberWithCurrencySymbol((Number($optional(product, 'pivot', 'price')) -
                            Number($optional(product, 'pivot', 'discount')))) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numberWithCurrencySymbol} from "../../../Helpers/Helpers";

    export default {
        name: "ExpandableOrderProducts",
        props: {
            data: {
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                numberWithCurrencySymbol
            }
        }
    }
</script>

<style scoped>

</style>